/**
 * Experimental: let users click an empty point on the office map to drop a pin and file a
 * workplace request anchored to that map location (office + floor + map-space x/y).
 *
 * Flip to `false` to disable the feature everywhere without removing the code.
 */
export const MAP_PIN_REQUEST_ENABLED = true;
